import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/[locale]/(listing)/CategoryPageBase.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/cms/link/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["renderRichTextToComponent"] */ "/vercel/path0/apps/web/src/components/cms/rich-text-renderer/renderRichTextToComponent.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useMicrocopy"] */ "/vercel/path0/apps/web/src/lib/contentful/microcopy/MicrocopyContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GetLiveUpdates","ModulesRenderer"] */ "/vercel/path0/apps/web/src/lib/contentful/modules-renderer/ModulesRenderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageHeading"] */ "/vercel/path0/packages/ui/src/components/content/page-heading/PageHeading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/vercel/path0/packages/ui/src/components/content/text/Text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/packages/ui/src/components/forms/button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/layout/box/Box.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/layout/flex/Flex.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ECCOIcon"] */ "/vercel/path0/packages/ui/src/components/media-and-icons/ecco-icon/ECCOIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextImage"] */ "/vercel/path0/packages/ui/src/components/media-and-icons/image/NextImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useThemeMediaQuery"] */ "/vercel/path0/packages/ui/src/hooks/useThemeMediaQuery.ts");
